import React, { useState, useEffect } from 'react';
import './Recurso.css';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import SendIcon from '@mui/icons-material/Send';

function Recurso({ questionNumber }) {
    const [showForm, setShowForm] = useState(false);
    const [recursoType, setRecursoType] = useState(''); // 'alteracao' or 'anulacao'
    const [reasoning, setReasoning] = useState('');
    const [recursos, setRecursos] = useState([]);
    const [userName] = useState(localStorage.getItem('userName') || 'Aluno');

    // Load recursos from localStorage on mount
    useEffect(() => {
        const savedRecursos = localStorage.getItem(`recursos_q${questionNumber}`);
        if (savedRecursos) {
            setRecursos(JSON.parse(savedRecursos));
        }
    }, [questionNumber]);

    // Save recursos to localStorage whenever they change
    useEffect(() => {
        if (recursos.length > 0) {
            localStorage.setItem(`recursos_q${questionNumber}`, JSON.stringify(recursos));
        }
    }, [recursos, questionNumber]);

    const handleSubmitRecurso = () => {
        if (!recursoType || !reasoning.trim()) {
            alert('Por favor, selecione o tipo de recurso e escreva a justificativa.');
            return;
        }

        const newRecurso = {
            id: Date.now(),
            type: recursoType,
            reasoning: reasoning,
            author: userName,
            date: new Date().toLocaleString('pt-BR'),
            likes: 0
        };

        setRecursos([newRecurso, ...recursos]);
        setRecursoType('');
        setReasoning('');
        setShowForm(false);
    };

    const handleLike = (recursoId) => {
        setRecursos(recursos.map(recurso => 
            recurso.id === recursoId 
                ? { ...recurso, likes: recurso.likes + 1 }
                : recurso
        ));
    };

    const handleNewRecurso = () => {
        setShowForm(true);
    };

    const handleCancelForm = () => {
        setShowForm(false);
        setRecursoType('');
        setReasoning('');
    };

    return (
        <div className="recurso-inline-content">
            <div className='question-body recurso'>
                    {!showForm && (
                        <button className="new-recurso-btn" onClick={handleNewRecurso}>
                            <span className="new-recurso-icon">+</span> Novo Recurso
                        </button>
                    )}

                    {showForm && (
                        <div className="recurso-form">
                            <h3>Novo Recurso</h3>
                            
                            <div className="recurso-type-selection">
                                <label>Tipo de Recurso:</label>
                                <div className="type-buttons">
                                    <button
                                        className={`type-btn ${recursoType === 'alteracao' ? 'active' : ''}`}
                                        onClick={() => setRecursoType('alteracao')}
                                    >
                                        Alteração de Gabarito
                                    </button>
                                    <button
                                        className={`type-btn ${recursoType === 'anulacao' ? 'active' : ''}`}
                                        onClick={() => setRecursoType('anulacao')}
                                    >
                                        Anulação da Questão
                                    </button>
                                </div>
                            </div>

                            <div className="recurso-reasoning">
                                <label>Justificativa:</label>
                                <textarea
                                    value={reasoning}
                                    onChange={(e) => setReasoning(e.target.value)}
                                    placeholder="Descreva os motivos para sua solicitação de recurso..."
                                    rows="6"
                                />
                            </div>

                            <div className="form-actions">
                                <button className="cancel-btn" onClick={handleCancelForm}>
                                    Cancelar
                                </button>
                                <button className="submit-btn" onClick={handleSubmitRecurso}>
                                    <SendIcon style={{ fontSize: 18, marginRight: 5 }} />
                                    Enviar Recurso
                                </button>
                            </div>
                        </div>
                    )}

                    <div className="recursos-list">
                        <h3>Recursos Solicitados ({recursos.length})</h3>
                        
                        {recursos.length === 0 ? (
                            <div className="no-recursos">
                                Nenhum recurso solicitado para esta questão.
                            </div>
                        ) : (
                            recursos.map((recurso) => (
                                <div key={recurso.id} className="recurso-item">
                                    <div className="recurso-item-header">
                                        <span className={`recurso-badge ${recurso.type}`}>
                                            {recurso.type === 'alteracao' ? 'Alteração de Gabarito' : 'Anulação'}
                                        </span>
                                        <span className="recurso-date">{recurso.date}</span>
                                    </div>
                                    
                                    <div className="recurso-item-author">
                                        Por: {recurso.author}
                                    </div>
                                    
                                    <div className="recurso-item-reasoning">
                                        {recurso.reasoning}
                                    </div>
                                    
                                    <div className="recurso-item-footer">
                                        <button 
                                            className="like-btn"
                                            onClick={() => handleLike(recurso.id)}
                                        >
                                            <ThumbUpOutlinedIcon style={{ fontSize: 20, marginRight: 5 }} />
                                            <span className="like-count">{recurso.likes}</span>
                                            <span className="like-text">Apoiar</span>
                                        </button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
    );
}

export default Recurso;